import { Card, CardContent } from '../ui/card';
import { formatDate } from '../../hooks/useAdminData';

const STATUS_COLORS = {
  new: 'bg-blue-100 text-blue-700',
  reviewed: 'bg-yellow-100 text-yellow-700',
  contacted: 'bg-green-100 text-green-700',
  completed: 'bg-gray-100 text-gray-600',
};

const STATUS_OPTIONS = ['new', 'reviewed', 'contacted', 'completed'];

export const ContactsList = ({ contacts, onUpdateStatus }) => (
  <div className="space-y-4" data-testid="admin-contacts-list">
    {contacts.length === 0 ? (
      <Card className="border-none shadow-md">
        <CardContent className="p-8 text-center text-gray-500">No contact submissions found.</CardContent>
      </Card>
    ) : (
      contacts.map((c) => (
        <Card key={c.id} className="border-none shadow-md hover:shadow-lg transition-all">
          <CardContent className="p-5">
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <h3 className="text-lg font-bold text-darkBrown">{c.name}</h3>
                  <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${STATUS_COLORS[c.status] || STATUS_COLORS.new}`}>
                    {c.status}
                  </span>
                </div>
                <p className="text-sm text-gray-600 mb-1">{c.email} {c.phone && `| ${c.phone}`}</p>
                {c.preferredDate && (
                  <p className="text-sm text-gray-500">
                    Preferred: {c.preferredDate} {c.preferredTime && `at ${c.preferredTime}`}
                  </p>
                )}
                <p className="text-gray-700 mt-2 line-clamp-2">{c.message}</p>
                <p className="text-xs text-gray-400 mt-2">{formatDate(c.timestamp)}</p>
              </div>
              <div className="flex-shrink-0">
                <select
                  value={c.status}
                  onChange={(e) => onUpdateStatus('contact', c.id, e.target.value)}
                  className="text-sm border rounded-md px-3 py-1.5"
                  data-testid={`admin-contact-status-${c.id}`}
                >
                  {STATUS_OPTIONS.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
              </div>
            </div>
          </CardContent>
        </Card>
      ))
    )}
  </div>
);
